module.exports = __webpack_public_path__ + "img/wanc.4d205084.png";